<template lang="html">
  <v-dialog
    scrollable
    :value="true"
    max-width="1200"
    content-class="fill-height"
    @input="$emit('close')"
  >
    <v-card :class="{large: !appSmall}" style="height: 100%">
      <v-card-title
        class="headline grey lighten-2 pa-0"
        style="height: 120px;position: relative;"
      >
        <div style="height: 60px;width: 100%;padding-right: 45px;padding-left: 15px;">
          <DataParamsPicker
            v-model="params"
          />
          <v-btn
            style="position: absolute; top: 5px; right: 0px;"
            icon
            @click="$emit('close')"
          >
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </div>

        <v-tabs
          dark
          background-color="primary"
          v-model="tab"
          style="width:100%;"
          centered
        >
          <v-tabs-slider color="white"></v-tabs-slider>
          <v-tab>Graph</v-tab>
          <v-tab>Data</v-tab>
        </v-tabs>
      </v-card-title>

      <v-card-text :class="{'pb-0': tab === 0, 'pb-3': tab === 1}" style="flex: 100">
        <GraphChart
          v-if="tab === 0"
          :params="params"
        />
        <DataTable
          v-else-if="tab === 1"
          :params="params"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import GraphChart from './GraphChart'
import DataTable from '../Data/DataTable'
import DataParamsPicker from '@/components/DataParamsPicker'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    DataParamsPicker,
    GraphChart,
    DataTable
  },
  props: {
    initialParams: {
      type: Object,
      default: () => ({
        testType: null,
        machine: null,
        dateRange: null
      })
    }
  },
  data () {
    return {
      params: {
        testType: null,
        machine: null,
        dateRange: null
      },
      tab: 0
    }
  },
  created () {
    this.params = cloneDeep(this.initialParams)
  }
}
</script>
